import { render } from "./OrderReceipt.vue?vue&type=template&id=23b1007a&scoped=true"
import script from "./OrderReceipt.vue?vue&type=script&lang=js"
export * from "./OrderReceipt.vue?vue&type=script&lang=js"

import "./OrderReceipt.vue?vue&type=style&index=0&id=23b1007a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b1007a"]])

export default __exports__